export enum WithdrawCommission {
  Withdraw = 1,
  WithdrawETH = 2,
  WithdrawNotETH = 3,
  DividendWithdraw = 6,
  SellRipeToken = 8,
  BuyRipeToken = 9,
  ReferralWithdrawUSDT = 10
}
